import { render } from "./AppLayoutDefault.vue?vue&type=template&id=39dda9ce&ts=true"
import script from "./AppLayoutDefault.vue?vue&type=script&lang=ts"
export * from "./AppLayoutDefault.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__